import React from 'react';
import { PNGS, SVGS } from '../../../assets';
import './waba-pre-requirements.scss';
import { WabaRequirementsCard } from '../waba-requirements-card/waba-requirements-card';
import ZoButton from '@zonofi/zo-components/input/zo-button/zo-button';

interface WabaPreRequirementsProps {
  onBackClick: () => void;
  onContinueClick: () => void;
  onSkipClick: () => void;
}

export const WabaPreRequirements: React.FC<WabaPreRequirementsProps> = ({
  onBackClick,
  onContinueClick,
  onSkipClick,
}) => {
  const requirements = [
    {
      icon: SVGS.MetaIcon,
      heading: 'Facebook Business Manager Account',
      description:
        'You need a Facebook Business Manager (FBM) account to create or link your WhatsApp Business profile. Make sure you have admin access.',
    },
    {
      icon: PNGS.Whatsapp,
      heading: 'WhatsApp Business Phone Number',
      description:
        'Use a number already logged into the WhatsApp Business App. You’ll be asked to scan a QR code during setup to link it without losing chat history (coexistence mode)',
    },
    {
      icon: SVGS.WebsiteEmail,
      heading: 'Business Website & Email',
      description:
        'A valid website and business email help Meta verify your business faster and improve approval chances.',
    },
    {
      icon: SVGS.LegalDocuments,
      heading: 'Legal Business Documents (if needed)',
      description: '',
    },
  ];
  return (
    <div className="waba-pre-requirements">
      <div className="waba-pre-requirements-container">
        <div className="waba-pre-requirements-container-header">
          <img
            src={PNGS.WabaSetupIcon}
            alt=""
            className="waba-pre-requirements-container-header-icon"
          />
          <div className="waba-pre-requirements-container-header-text">
            <span className="waba-pre-requirements-container-header-text-heading primary-font-bold">
              WABA Setup Pre-requirements
            </span>
            <span className="waba-pre-requirements-container-header-text-description primary-font-regular">
              To set up a WABA, Meta requires a Facebook Business Profile.
              During sign-up, you can create a new profile or use an existing
              one, then proceed to create your WhatsApp Business Account.
            </span>
          </div>
        </div>
        <div className="waba-pre-requirements-container-body">
          {requirements.map((item) => {
            return (
              <WabaRequirementsCard
                icon={item.icon}
                heading={item.heading}
                description={item.description}
              />
            );
          })}
        </div>
        <ZoButton
          variant="secondary"
          isLoading={false}
          onClick={onSkipClick}
          label={'I’ll do it Later'}
          style={{ border: '1px solid #32A7E8' }}
          className=""
        />
      </div>
      <div className="waba-pre-requirements-footer">
        <div className="waba-pre-requirements-footer-buttons">
          <ZoButton
            onClick={onBackClick}
            label={'Back'}
            startIcon={<img src={SVGS.LeftArrowBlue} alt="" />}
            className="waba-pre-requirements-footer-buttons-back"
          />
          <ZoButton
            onClick={onContinueClick}
            label={'Continue'}
            endIcon={<img src={SVGS.RightArrowIcon} alt="" />}
            className="waba-pre-requirements-footer-buttons-continue"
          />
        </div>
      </div>
    </div>
  );
};
